// source: src/common/person/trend.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_person_daily_value_pb = require('../../../src/common/person/daily_value_pb.js');
goog.object.extend(proto, src_common_person_daily_value_pb);
var src_common_person_weekly_value_pb = require('../../../src/common/person/weekly_value_pb.js');
goog.object.extend(proto, src_common_person_weekly_value_pb);
var src_common_person_monthly_value_pb = require('../../../src/common/person/monthly_value_pb.js');
goog.object.extend(proto, src_common_person_monthly_value_pb);
goog.exportSymbol('proto.loupe.common.person.Trend', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.person.Trend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.person.Trend.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.person.Trend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.person.Trend.displayName = 'proto.loupe.common.person.Trend';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.person.Trend.repeatedFields_ = [4,5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.person.Trend.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.person.Trend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.person.Trend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.person.Trend.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    shortAverage: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    longAverage: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    dailyValuesList: jspb.Message.toObjectList(msg.getDailyValuesList(),
    src_common_person_daily_value_pb.DailyValue.toObject, includeInstance),
    weeklyValuesList: jspb.Message.toObjectList(msg.getWeeklyValuesList(),
    src_common_person_weekly_value_pb.WeeklyValue.toObject, includeInstance),
    monthlyValuesList: jspb.Message.toObjectList(msg.getMonthlyValuesList(),
    src_common_person_monthly_value_pb.MonthlyValue.toObject, includeInstance),
    dailyAverage: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    weeklyAverage: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    monthlyAverage: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.person.Trend}
 */
proto.loupe.common.person.Trend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.person.Trend;
  return proto.loupe.common.person.Trend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.person.Trend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.person.Trend}
 */
proto.loupe.common.person.Trend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setShortAverage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongAverage(value);
      break;
    case 4:
      var value = new src_common_person_daily_value_pb.DailyValue;
      reader.readMessage(value,src_common_person_daily_value_pb.DailyValue.deserializeBinaryFromReader);
      msg.addDailyValues(value);
      break;
    case 5:
      var value = new src_common_person_weekly_value_pb.WeeklyValue;
      reader.readMessage(value,src_common_person_weekly_value_pb.WeeklyValue.deserializeBinaryFromReader);
      msg.addWeeklyValues(value);
      break;
    case 6:
      var value = new src_common_person_monthly_value_pb.MonthlyValue;
      reader.readMessage(value,src_common_person_monthly_value_pb.MonthlyValue.deserializeBinaryFromReader);
      msg.addMonthlyValues(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDailyAverage(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWeeklyAverage(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMonthlyAverage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.person.Trend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.person.Trend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.person.Trend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.person.Trend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShortAverage();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getLongAverage();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getDailyValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      src_common_person_daily_value_pb.DailyValue.serializeBinaryToWriter
    );
  }
  f = message.getWeeklyValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      src_common_person_weekly_value_pb.WeeklyValue.serializeBinaryToWriter
    );
  }
  f = message.getMonthlyValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      src_common_person_monthly_value_pb.MonthlyValue.serializeBinaryToWriter
    );
  }
  f = message.getDailyAverage();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getWeeklyAverage();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getMonthlyAverage();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.loupe.common.person.Trend.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.person.Trend} returns this
 */
proto.loupe.common.person.Trend.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double short_average = 2;
 * @return {number}
 */
proto.loupe.common.person.Trend.prototype.getShortAverage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.person.Trend} returns this
 */
proto.loupe.common.person.Trend.prototype.setShortAverage = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double long_average = 3;
 * @return {number}
 */
proto.loupe.common.person.Trend.prototype.getLongAverage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.person.Trend} returns this
 */
proto.loupe.common.person.Trend.prototype.setLongAverage = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * repeated DailyValue daily_values = 4;
 * @return {!Array<!proto.loupe.common.person.DailyValue>}
 */
proto.loupe.common.person.Trend.prototype.getDailyValuesList = function() {
  return /** @type{!Array<!proto.loupe.common.person.DailyValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_person_daily_value_pb.DailyValue, 4));
};


/**
 * @param {!Array<!proto.loupe.common.person.DailyValue>} value
 * @return {!proto.loupe.common.person.Trend} returns this
*/
proto.loupe.common.person.Trend.prototype.setDailyValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.loupe.common.person.DailyValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.person.DailyValue}
 */
proto.loupe.common.person.Trend.prototype.addDailyValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.loupe.common.person.DailyValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.person.Trend} returns this
 */
proto.loupe.common.person.Trend.prototype.clearDailyValuesList = function() {
  return this.setDailyValuesList([]);
};


/**
 * repeated WeeklyValue weekly_values = 5;
 * @return {!Array<!proto.loupe.common.person.WeeklyValue>}
 */
proto.loupe.common.person.Trend.prototype.getWeeklyValuesList = function() {
  return /** @type{!Array<!proto.loupe.common.person.WeeklyValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_person_weekly_value_pb.WeeklyValue, 5));
};


/**
 * @param {!Array<!proto.loupe.common.person.WeeklyValue>} value
 * @return {!proto.loupe.common.person.Trend} returns this
*/
proto.loupe.common.person.Trend.prototype.setWeeklyValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.loupe.common.person.WeeklyValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.person.WeeklyValue}
 */
proto.loupe.common.person.Trend.prototype.addWeeklyValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.loupe.common.person.WeeklyValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.person.Trend} returns this
 */
proto.loupe.common.person.Trend.prototype.clearWeeklyValuesList = function() {
  return this.setWeeklyValuesList([]);
};


/**
 * repeated MonthlyValue monthly_values = 6;
 * @return {!Array<!proto.loupe.common.person.MonthlyValue>}
 */
proto.loupe.common.person.Trend.prototype.getMonthlyValuesList = function() {
  return /** @type{!Array<!proto.loupe.common.person.MonthlyValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_person_monthly_value_pb.MonthlyValue, 6));
};


/**
 * @param {!Array<!proto.loupe.common.person.MonthlyValue>} value
 * @return {!proto.loupe.common.person.Trend} returns this
*/
proto.loupe.common.person.Trend.prototype.setMonthlyValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.loupe.common.person.MonthlyValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.person.MonthlyValue}
 */
proto.loupe.common.person.Trend.prototype.addMonthlyValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.loupe.common.person.MonthlyValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.person.Trend} returns this
 */
proto.loupe.common.person.Trend.prototype.clearMonthlyValuesList = function() {
  return this.setMonthlyValuesList([]);
};


/**
 * optional double daily_average = 7;
 * @return {number}
 */
proto.loupe.common.person.Trend.prototype.getDailyAverage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.person.Trend} returns this
 */
proto.loupe.common.person.Trend.prototype.setDailyAverage = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double weekly_average = 8;
 * @return {number}
 */
proto.loupe.common.person.Trend.prototype.getWeeklyAverage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.person.Trend} returns this
 */
proto.loupe.common.person.Trend.prototype.setWeeklyAverage = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double monthly_average = 9;
 * @return {number}
 */
proto.loupe.common.person.Trend.prototype.getMonthlyAverage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.person.Trend} returns this
 */
proto.loupe.common.person.Trend.prototype.setMonthlyAverage = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


goog.object.extend(exports, proto.loupe.common.person);
